import React, { useState } from "react";
import { motion } from "framer-motion";

import RewardBackground from "../../assets/images/cp/Group 1000004870 3.png";
import TitleRewardBackground from "../../assets/images/cp/title (2).png";

import { useTranslation } from "react-i18next";
import TimerComponent from "./TimerComponent";
import fallbackImage from "../../assets/icons/selected_male.png";
import fallbackImage1 from "../../assets/icons/selected_female.png";
import fallbackImage2 from "../../assets/images/cp/1E0FDOUK36G2XPEK 1.png";

import MainRingFemale1 from "../../assets/images/cp/girls.png";
import MainRingMen1 from "../../assets/images/cp/boy.png";
import titleBackground from "../../assets/images/cp/Rectangle 1171.png";
import DialogButton from "../../assets/images/cp/DialogButton (1).png";

import Dialog from "./Dialog";
// File names are swapped: "active 2" is the pink selected tab, "desecivate 1" is the blue idle one
import activeTabBar1 from "../../assets/images/cp/active 2.png";
import tabBar1 from "../../assets/images/cp/desecivate 1.png";
import Top1Frame from "../../assets/images/cp/top1cp 1.png";
import PurpleFrame from "../../assets/images/cp/tqnk 1.png";
import BlueFrame from "../../assets/images/cp/tqnk 2.png";
import ScoreBar from "../../assets/images/cp/Frame 1984080860.png";
// File names are swapped: "top 3 2" is the "2" badge and "top 3 1" is the "3" badge
import Rank2Badge from "../../assets/images/cp/top 3 2.png";
import Rank3Badge from "../../assets/images/cp/top 3 1.png";
import RowBackground from "../../assets/images/cp/Group 1000004877 1.png";
import PinkRing from "../../assets/images/cp/find_cp_1 1.png";
import BlueRing from "../../assets/images/cp/find_cp_2 1.png";
import RowHeart from "../../assets/images/cp/cp_tray_4 1.png";
import PulseLine from "../../assets/images/cp/icon_cp_dialog_line2 1.png";
import BarBackground from "../../assets/images/cp/min 1.png";
import BarRing from "../../assets/images/cp/message_cp_user_avatar_bg 1.png";
import BarPlusSlot from "../../assets/images/cp/Group 1000004880.png";
import BarHeart from "../../assets/images/cp/cp_tray_3 1.png";

// Avatar hole centers (% of the frame image) measured from each frame's transparent circles
const TOP1_HOLES = { left: [37.2, 62.1], right: [63, 62.3], size: 20 };
const SMALL_HOLES = { left: [34.3, 45.7], right: [66.1, 45.7], size: 29.5 };
// Ring frames in the last-winners row: width is % of the row card, hole values are % of the ring image
const RING_WIDTH = 19;
const PINK_RING_HOLE = { x: 64.4, y: 50, size: 53 };
const BLUE_RING_HOLE = { x: 34.5, y: 50, size: 51 };

const Design = ({ CpTopRan, AllEvents }) => {
  const [activeTab, setActiveTab] = useState("tab2");
  const { t } = useTranslation();
  const [imageErrors, setImageErrors] = useState({});
  const [imageErrors1, setImageErrors1] = useState({});
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);
  const imageBaseUrl = "https://media.smolivechat.com/";

  // Handle image error by updating the imageErrors state
  const handleError = (imagePath) => {
    setImageErrors((prevState) => ({
      ...prevState,
      [imagePath]: true, // mark this path as failed
    }));
  };
  const handleError1 = (imagePath) => {
    setImageErrors1((prevState) => ({
      ...prevState,
      [imagePath]: true, // mark this path as failed
    }));
  };
  // Reusable Score Badge Component
  const ScoreBadge = ({ score }) => (
    <p className="text-shadow-[2px_2px_5px_rgba(0,0,0,0.3)] font-cairo px-5 flex flex-row items-center gap-1 gradientText   font-bold text-[14px]  leading-[54.32px]">
      {parseInt(score) || "--"}
    </p>
  );
  // Reusable Avatar Image Component
  const AvatarImage = ({
    imageUrl,
    imageErrors,
    fallbackImage1,
    imageBaseUrl,
    handleError,
    size,
  }) => (
    <img
      src={
        imageErrors[imageUrl] ? fallbackImage1 : `${imageBaseUrl}${imageUrl}`
      }
      onError={() => handleError(imageUrl)}
      className={`${size} rounded-full border-2 border-white shadow-md`}
      alt="avatar"
    />
  );
  // Reusable Winner List Item Component
  const WinnerListItem = ({
    item,
    position,
    imageBaseUrl,
    fallbackImage1,
    imageErrors,
    handleError,
  }) => (
    <div className="CpRankBackground xss:h-[73px] sm:h-[80px] my-1 p-2 rounded-lg">
      <div className="flex flex-row justify-between items-center h-full">
        <div className="w-[70%] flex flex-row items-center">
          <p className="font-semibold w-[15%] text-lg text-[#FDF19F] font-lemon">
            {position}
          </p>
          <div className="relative flex flex-row items-center gap-2">
            <AvatarImage
              imageUrl={item.sender_cp_img}
              imageErrors={imageErrors}
              fallbackImage1={fallbackImage1}
              imageBaseUrl={imageBaseUrl}
              handleError={handleError}
              size="w-14 h-14"
            />
            <AvatarImage
              imageUrl={item.receiver_cp_img}
              imageErrors={imageErrors}
              fallbackImage1={fallbackImage1}
              imageBaseUrl={imageBaseUrl}
              handleError={handleError}
              size="w-14 h-14"
            />
          </div>
        </div>
        <div className="w-[25%] flex flex-row justify-end items-center">
          <ScoreBadge score={item.exp} />
        </div>
      </div>
    </div>
  );
  // Reusable Winners List Component
  const WinnersList = ({
    winners,
    imageBaseUrl,
    fallbackImage1,
    imageErrors,
    handleError,
  }) => {
    if (!winners || winners.length === 0) return null;

    return (
      <div className="mx-auto  w-[90%]  flex flex-col relative">
        {winners.map((item, index) => (
          <WinnerListItem
            key={index}
            item={item}
            position={index + 4}
            imageBaseUrl={imageBaseUrl}
            fallbackImage1={fallbackImage1}
            imageErrors={imageErrors}
            handleError={handleError}
          />
        ))}
      </div>
    );
  };
  // Reusable Score Display Component
  const ScoreDisplay = ({ score, textSize = "text-sm" }) => (
    <div className="relative h-[25px] w-auto">
      <img
        src={titleBackground}
        alt="score background"
        className=" h-[25px] mx-auto  w-[80%]"
      />
      <div className="absolute flex flex-row gap-1 items-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <p
          className={`font-cairo gradientText ${textSize} font-bold text-center`}
        >
          {parseInt(score) || "--"}
        </p>
      </div>
    </div>
  );
  // Reusable Title with Coin Component
  const TitleWithCoin = ({ text, textSize = "text-lg", ringSize }) => (
    <div className="relative h-[25px] w-auto mt-2">
      <img
        src={titleBackground}
        alt="title background"
        className="w-full h-[25px]  "
      />
      <div className="absolute flex flex-row justify-center gap-1 items-center w-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <p
          className={`font-cairo w-full   text-white ${textSize} font-bold text-center truncate `}
        >
          {text || "--"}
        </p>
      </div>
    </div>
  );
  // Reusable Winner Avatar Component
  const WinnerAvatar = ({ imageUrl, name, ringSize, avatarSize, textSize }) => (
    <div className="w-[50%] relative">
      <img
        src={MainRingFemale1}
        className={`mx-auto ${ringSize} z-20 relative`}
        alt="winner ring"
      />
      <img
        src={
          imageErrors[imageUrl] ? fallbackImage1 : `${imageBaseUrl}${imageUrl}`
        }
        alt={name}
        onError={() => handleError(imageUrl)}
        className={`absolute top-[42%] z-10 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${avatarSize} rounded-full border-2 border-white shadow-lg`}
      />
      <TitleWithCoin text={name} textSize={textSize} />
    </div>
  );
  const WinnerAvatar1 = ({
    imageUrl,
    name,
    ringSize,
    avatarSize,
    textSize,
  }) => (
    <div className="w-[50%] relative">
      <img
        src={MainRingMen1}
        className={`mx-auto ${ringSize} z-20 relative`}
        alt="winner ring"
      />
      <img
        src={
          imageErrors[imageUrl] ? fallbackImage1 : `${imageBaseUrl}${imageUrl}`
        }
        alt={name}
        onError={() => handleError(imageUrl)}
        className={`absolute top-[42%] z-10 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${avatarSize} rounded-full border-2 border-white shadow-lg`}
      />
      <TitleWithCoin text={name} textSize={textSize} ringSize={"24px"} />
    </div>
  );
  const WinnerAvatar2 = ({
    imageUrl,
    name,
    ringSize,
    avatarSize,
    textSize,
  }) => (
    <div className="w-[45%] relative">
      <img
        src={MainRingFemale1}
        className={`mx-auto ${ringSize} z-20 relative`}
        alt="winner ring"
      />
      <img
        src={
          imageErrors[imageUrl] ? fallbackImage1 : `${imageBaseUrl}${imageUrl}`
        }
        alt={name}
        onError={() => handleError(imageUrl)}
        className={`absolute top-[42%] z-10 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${avatarSize} rounded-full border-2 border-white shadow-lg`}
      />
      <div className="relative h-[25px] w-auto mt-2">
        <img
          src={titleBackground}
          alt="title background"
          className="w-full h-[25px]  "
        />
        <div className="absolute flex flex-row justify-center gap-1 items-center w-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <p
            className={`font-cairo w-full   text-white ${textSize} font-bold text-center truncate `}
          >
            {name || "--"}
          </p>
        </div>
      </div>{" "}
    </div>
  );
  const WinnerAvatar3 = ({
    imageUrl,
    name,
    ringSize,
    avatarSize,
    textSize,
  }) => (
    <div className="w-[45%] relative">
      <img
        src={MainRingMen1}
        className={`mx-auto ${ringSize} z-20 relative`}
        alt="winner ring"
      />
      <img
        src={
          imageErrors[imageUrl] ? fallbackImage : `${imageBaseUrl}${imageUrl}`
        }
        alt={name}
        onError={() => handleError(imageUrl)}
        className={`absolute top-[42%] z-10 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${avatarSize} rounded-full border-2 border-white shadow-lg`}
      />
      <div className="relative h-[25px] w-auto mt-2">
        <img
          src={titleBackground}
          alt="title background"
          className="w-full h-[25px]  "
        />
        <div className="absolute flex flex-row justify-center gap-1 items-center w-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <p
            className={`font-cairo w-full   text-white ${textSize} font-bold text-center truncate `}
          >
            {name || "--"}
          </p>
        </div>
      </div>{" "}
    </div>
  );
  // Reusable Winner Pair Component
  const WinnerPair = ({
    winnerData,
    position,
    ringSize = "w-32 h-32",
    avatarSize = "w-20 h-20",
    textSize = "text-sm",
  }) => {
    if (!winnerData) return null;

    return (
      <div className="flex flex-col gap-2 justify-center items-center mb-3">
        <div className="flex flex-row justify-between w-[90%] mx-auto items-center">
          <WinnerAvatar1
            imageUrl={winnerData.sender_cp_img}
            name={winnerData.sender_cp_name}
            ringSize={ringSize}
            avatarSize={avatarSize}
            textSize={textSize}
          />

          <WinnerAvatar
            imageUrl={winnerData.receiver_cp_img}
            name={winnerData.receiver_cp_name}
            ringSize={ringSize}
            avatarSize={avatarSize}
            textSize={textSize}
          />
        </div>
      </div>
    );
  };
  const WinnerPair1 = ({
    winnerData,
    position,
    ringSize = "w-32 h-32",
    avatarSize = "w-20 h-20",
    textSize = "text-sm",
  }) => {
    if (!winnerData) return null;

    return (
      <div className="flex flex-col gap-2 justify-center items-center mb-3">
        <div className="flex flex-row justify-between w-[90%] mx-auto items-center">
          <WinnerAvatar1
            imageUrl={winnerData.sender_cp_img}
            name={winnerData.sender_cp_name}
            ringSize={ringSize}
            avatarSize={avatarSize}
            textSize={textSize}
          />

          <WinnerAvatar
            imageUrl={winnerData.receiver_cp_img}
            name={winnerData.receiver_cp_name}
            ringSize={ringSize}
            avatarSize={avatarSize}
            textSize={textSize}
          />
        </div>
        <ScoreDisplay score={winnerData.exp} />
      </div>
    );
  };
  // Left avatar sits in the pink hole, so put the female partner (gender 0) first
  const getCouple = (winner) => {
    const sender = { img: winner.sender_cp_img, name: winner.sender_cp_name };
    const receiver = {
      img: winner.receiver_cp_img,
      name: winner.receiver_cp_name,
    };
    return winner.sender_cp_gender === 0
      ? [sender, receiver]
      : [receiver, sender];
  };
  // Winner couple inside a heart frame, with the score on a pink bar underneath
  const PodiumCouple = ({
    winner,
    frame,
    holes,
    className,
    barClassName,
    glassBar,
    badge,
  }) => {
    if (!winner) return null;

    return (
      <div className={`absolute ${className}`}>
        <div className="relative w-full">
          {getCouple(winner).map((person, index) => {
            const [x, y] = index === 0 ? holes.left : holes.right;
            return (
              <img
                key={index}
                src={
                  imageErrors[person.img]
                    ? index === 0
                      ? fallbackImage1
                      : fallbackImage
                    : `${imageBaseUrl}${person.img}`
                }
                onError={() => handleError(person.img)}
                alt={person.name}
                className="absolute z-10 -translate-x-1/2 -translate-y-1/2 rounded-full object-cover"
                style={{
                  left: `${x}%`,
                  top: `${y}%`,
                  width: `${holes.size}%`,
                  aspectRatio: "1 / 1",
                }}
              />
            );
          })}
          <img
            src={frame}
            alt=""
            className="relative z-20 block w-full h-auto"
          />
          {badge && (
            <img
              src={badge.src}
              alt=""
              className="absolute left-1/2 z-30 -translate-x-1/2"
              style={{ top: "77%", width: `${badge.width}%` }}
            />
          )}
        </div>
        <div className={`relative z-20 mx-auto ${barClassName}`}>
          {glassBar ? (
            // Frosted strip (Figma "background blur"): shows the scene blurred behind the score
            <div className="w-full aspect-[305/56] bg-white/10 backdrop-blur-[6px]" />
          ) : (
            <img
              src={ScoreBar}
              alt=""
              className="block w-[150px] mx-auto h-[29px]"
            />
          )}
          <p className="absolute inset-0 flex items-center justify-center font-cairo font-bold text-[16px] leading-none text-[#FFE79D] [text-shadow:0_1px_3px_rgba(120,20,60,0.85)]">
            {parseInt(winner.exp) || "--"}
          </p>
        </div>
      </div>
    );
  };
  // Row card: number tag, pink/blue avatar rings, heart emblem and score pill
  const WinnerRow = ({ winner, position }) => {
    const [first, second] = getCouple(winner);
    const rings = [
      {
        person: first,
        ring: PinkRing,
        hole: PINK_RING_HOLE,
        cx: 25.6,
        fallback: fallbackImage1,
      },
      {
        person: second,
        ring: BlueRing,
        hole: BLUE_RING_HOLE,
        cx: 81,
        fallback: fallbackImage,
      },
    ];

    return (
      <div className="relative w-full">
        <img src={RowBackground} alt="" className="block w-full h-auto" />
        <p
          className="absolute -translate-x-1/2 -translate-y-1/2 -rotate-[18deg] font-cairo font-bold text-[16px] leading-none text-[#F284B2]"
          style={{ left: "8.7%", top: "48%" }}
        >
          {position}
        </p>
        {rings.map(({ person, ring, hole, cx, fallback }) => (
          <div
            key={cx}
            className="absolute"
            style={{
              width: `${RING_WIDTH}%`,
              left: `${cx - (hole.x * RING_WIDTH) / 100}%`,
              top: "50%",
              transform: `translateY(-${hole.y}%)`,
            }}
          >
            <div className="relative">
              <img
                src={
                  imageErrors[person.img]
                    ? fallback
                    : `${imageBaseUrl}${person.img}`
                }
                onError={() => handleError(person.img)}
                alt={person.name}
                className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full object-cover"
                style={{
                  left: `${hole.x}%`,
                  top: `${hole.y}%`,
                  width: `${hole.size}%`,
                  aspectRatio: "1 / 1",
                }}
              />
              <img src={ring} alt="" className="relative block w-full h-auto" />
            </div>
          </div>
        ))}
        {[39.6, 67.1].map((left) => (
          <img
            key={left}
            src={PulseLine}
            alt=""
            className="absolute w-[10%] h-auto -translate-x-1/2 -translate-y-1/2"
            style={{ left: `${left}%`, top: "47%" }}
          />
        ))}
        <img
          src={RowHeart}
          alt=""
          className="absolute w-[13%] h-auto -translate-x-1/2 -translate-y-1/2"
          style={{ left: "53.2%", top: "38%" }}
        />
        <p
          className="absolute -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-gradient-to-r from-[#C86DF5] to-[#F0489F] px-2.5 font-cairo font-bold text-[11px] leading-[18px] text-white"
          style={{ left: "53.2%", top: "80%" }}
        >
          {parseInt(winner.exp) || "--"}
        </p>
      </div>
    );
  };
  // Fixed bar with my CP: rank, my avatar, heart + score, and the partner (or a "+" slot until linked)
  const MyCpBar = () => {
    const myCp = CpTopRan?.my_cp;
    const slots = [
      { person: myCp?.sender, cx: 24.7, fallback: fallbackImage },
      { person: myCp?.receiver, cx: 80.8, fallback: fallbackImage1 },
    ];

    return (
      <div className="fixed inset-x-0 bottom-0 z-50">
        <img src={BarBackground} alt="" className="block w-full h-auto" />
        <p
          className="absolute -translate-x-1/2 -translate-y-1/2 font-cairo text-[22px] font-bold leading-none text-[#F58AB6]"
          style={{ left: "9.1%", top: "62%" }}
        >
          {myCp?.rank ?? "--"}
        </p>
        {slots.map(({ person, cx, fallback }) => (
          <React.Fragment key={cx}>
            <div
              className="absolute -translate-x-1/2 -translate-y-1/2"
              style={{ left: `${cx}%`, top: "59%", width: "16.3%" }}
            >
              {person ? (
                <div className="relative">
                  <img
                    src={
                      imageErrors[person.image]
                        ? fallback
                        : `${imageBaseUrl}${person.image}`
                    }
                    onError={() => handleError(person.image)}
                    alt={person.name}
                    className="absolute left-1/2 top-1/2 w-[88%] -translate-x-1/2 -translate-y-1/2 rounded-full object-cover"
                    style={{ aspectRatio: "1 / 1" }}
                  />
                  <img
                    src={BarRing}
                    alt=""
                    className="relative block w-full h-auto"
                  />
                </div>
              ) : (
                <img src={BarPlusSlot} alt="" className="block w-full h-auto" />
              )}
            </div>
            {person && (
              <p
                className="absolute max-w-[24%] -translate-x-1/2 -translate-y-1/2 truncate font-cairo text-[14px] font-bold leading-[18px] text-[#F58AB6] [text-shadow:0_1px_0_#fff,0_0_6px_rgba(245,138,182,0.5)]"
                style={{ left: `${cx}%`, top: "86%" }}
              >
                {person.name}
              </p>
            )}
          </React.Fragment>
        ))}
        <img
          src={BarHeart}
          alt=""
          className="absolute h-auto w-[20.7%] -translate-x-1/2 -translate-y-1/2"
          style={{ left: "50.3%", top: "56%" }}
        />
        <p
          className="absolute -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-gradient-to-r from-[#C86DF5] to-[#F0489F] px-2.5 font-cairo text-[11px] font-bold leading-[18px] text-white"
          style={{ left: "50.3%", top: "86%" }}
        >
          {parseInt(myCp?.exp) || 0}
        </p>
      </div>
    );
  };
  const renderTabContents = (data, tabId) => {
    if (activeTab === "tab2") {
      const winners = CpTopRan?.rank || [];

      return (
        <div className="tab-panel relative top-[-36px] pb-[38vw] w-full flex flex-col justify-center items-center   text-center">
          <div
            className="relative w-full  "
            style={{ aspectRatio: "261 / 313" }}
          >
            <PodiumCouple
              winner={winners[0]}
              frame={Top1Frame}
              holes={TOP1_HOLES}
              className="left-[2.5%] top-[9%] w-[95%]"
              barClassName="w-[47.6%] mt-[5%]"
              glassBar
            />
            <PodiumCouple
              winner={winners[1]}
              frame={PurpleFrame}
              holes={SMALL_HOLES}
              badge={{ src: Rank2Badge, width: 25 }}
              className="left-[1%] top-[60%] w-[48%]"
              barClassName="w-full mt-3"
            />
            <PodiumCouple
              winner={winners[2]}
              frame={BlueFrame}
              holes={SMALL_HOLES}
              badge={{ src: Rank3Badge, width: 23.6 }}
              className="left-[51%] top-[60%] w-[48%]"
              barClassName="w-full mt-3"
            />
          </div>
          {CpTopRan?.rank?.length > 3 && (
            <div className="flex w-[92%] flex-col gap-3 pb-6 pt-10">
              {CpTopRan.rank.slice(3).map((winner, index) => (
                <WinnerRow
                  key={`${winner.sender_cp_id}-${winner.receiver_cp_id}`}
                  winner={winner}
                  position={index + 4}
                />
              ))}
            </div>
          )}
          <MyCpBar />
        </div>
      );
    } else if (activeTab === "tab3") {
      return (
        <div className="  xxs:min-h-[989px] sm:min-h-[1052px] relative top-[-36px] tab-panel">
          <div className=" relative top-[-40px] tab-panel">
            <div className="pt-7  -  relative flex flex-col items-center text-center">
              <div className="  w-full mx-auto">
                {[
                  {
                    title: t("Top 1"),
                    rewards: CpTopRan?.target_rewards?.top_1,
                  },
                  {
                    title: t("Top 2"),
                    rewards: CpTopRan?.target_rewards?.top_2,
                  },
                  {
                    title: t("Top 3"),
                    rewards: CpTopRan?.target_rewards?.top_3,
                  },
                ].map((section, sectionIndex) => (
                  <motion.div
                    key={sectionIndex}
                    className=" CpBackGround w-[100%] mb-8"
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      delay: sectionIndex * 0.15,
                      duration: 0.5,
                      ease: "easeOut",
                    }}
                  >
                    <motion.div
                      className="relative w-[160px] h-[50px] top-[11%] mx-auto mb-4 flex items-center justify-center"
                      initial={{ opacity: 0, scale: 0.6 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{
                        delay: sectionIndex * 0.15 + 0.2,
                        type: "spring",
                        stiffness: 260,
                        damping: 18,
                      }}
                    >
                      <img
                        src={TitleRewardBackground}
                        alt="reward background"
                        className="absolute inset-0 w-full h-full object-contain"
                      />
                      <p className="relative flex items-center justify-center text-center font-cairo text-[18px] leading-[21px] font-semibold text-[#C73752]">
                        {section.title}
                      </p>
                    </motion.div>

                    <div className="rounded-2xl top-[15%] px-3 p-2 relative my-3">
                      <div className="flex flex-wrap justify-center gap-1">
                        {section.rewards?.length > 0 ? (
                          section.rewards.map((item, index) => (
                            <motion.div
                              key={`${item.id || item.name}-${index}`}
                              className="rounded-2xl w-[110px] h-[130px] flex flex-col items-center"
                              initial={{ opacity: 0, scale: 0.5, y: 20 }}
                              animate={{ opacity: 1, scale: 1, y: 0 }}
                              transition={{
                                delay:
                                  sectionIndex * 0.15 + 0.35 + index * 0.07,
                                type: "spring",
                                stiffness: 240,
                                damping: 16,
                              }}
                            >
                              <div className="relative">
                                <img
                                  src={RewardBackground}
                                  alt="reward background"
                                  className="w-[100px] h-[100px] "
                                />
                                <img
                                  src={
                                    imageErrors[item?.image]
                                      ? fallbackImage2
                                      : `${imageBaseUrl}${item?.image}`
                                  }
                                  alt={item.name}
                                  onError={() => handleError(item?.image)}
                                  className="absolute inset-0 m-auto rounded-full w-[70px] h-[70px] object-cover shadow-md"
                                />
                              </div>
                              <p className="text-[10px] font-cairo text-[#C73752] font-bold w-full text-center   mt-2">
                                {item.name}
                              </p>
                            </motion.div>
                          ))
                        ) : (
                          <p className="text-xs font-medium text-white py-3">
                            {t("no data available")}
                          </p>
                        )}
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }
  };
  return (
    <div className="rewardBgs overflow-hidden">
      <div className="cp relative mx-auto">
        {/* Rules Button */}
        <div className="absolute top-[15%] z-[9999] right-0">
          <div
            onClick={openDialog}
            className="relative inline-block cursor-pointer"
          >
            <img
              src={DialogButton}
              alt="rules"
              className=" w-[86px] md:[200px] h-[50px]"
            />
            <p className="absolute font-normal text-[#FFFBFF] top-[47%] left-[68%] transform -translate-x-1/2 -translate-y-1/2 text-[18px] leading-none tracking-normal text-center">
              {t("Rules")}
            </p>
          </div>
        </div>

        <Dialog
          isOpen={isDialogOpen}
          closeDialog={closeDialog}
          description={CpTopRan?.desc}
        />
      </div>

      <div className="relative">
        {/* Timer: anchored to the hero's bottom edge (margins in % resolve against the page width),
            so it lands in the same spot on every screen height */}
        <div className="absolute top-0 mt-[-53%] w-full">
          {CpTopRan?.time && <TimerComponent initialTime={CpTopRan.time} />}
        </div>
        {/* Tab Navigation: the tab art keeps its own ratio, the row keeps its 40px of layout height */}
        <div className="flex z-20 w-full h-[40px] relative top-[-88px] items-start justify-around">
          {[
            { id: "tab2", label: "Rank" },
            { id: "tab3", label: "Rewards" },
          ].map((tab) => (
            <div
              key={tab.id}
              className={`relative w-[47%] cursor-pointer ${
                activeTab === tab.id ? "active" : ""
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              <img
                src={activeTab === tab.id ? activeTabBar1 : tabBar1}
                alt={`${tab.label} tab`}
                className="block w-full h-auto"
              />
              <p
                className={`absolute inset-0 flex items-center justify-center text-center font-cairo font-semibold text-[20px] leading-[23px] [text-shadow:0px_0px_4px_rgba(0,0,0,0.25)] ${
                  activeTab === tab.id
                    ? "text-[#5D0805]"
                    : "text-[rgba(254,255,255,0.4)]"
                }`}
              >
                {t(tab.label)}
              </p>
            </div>
          ))}
        </div>

        {renderTabContents()}
      </div>
    </div>
  );
};

export default Design;
{
  /* <div className="absolute w-full loadingg bottom-0 ">
         {CpTopRan?.my_cp?.sender ? (
          <img
            alt={CpTopRan?.my_cp?.sender?.uuid} // Add alt text for accessibility
            src={
              imageErrors[CpTopRan?.my_cp?.sender?.image] // Check if this image has an error
                ? fallbackImage1
                : `${imageBaseUrl}${CpTopRan?.my_cp?.sender?.image}`
            }
            onError={() => handleError(CpTopRan?.my_cp?.sender?.image)} // Handle error for individual image
            className="absolute left-[3.5rem] rounded-full w-16 top-[0.8rem] h-16"
          />
        ) : (
          <img
            src={fallbackImage1}
            className="absolute left-[3.5rem] rounded-full w-16 top-[0.8rem] h-16"
          />
        )}
         {CpTopRan?.my_cp?.receiver ? (
          <img
            alt={CpTopRan?.my_cp?.receiver?.uuid} // Add alt text for accessibility
            src={
              imageErrors[CpTopRan?.my_cp?.receiver?.image] // Check if this image has an error
                ? fallbackImage
                : `${imageBaseUrl}${CpTopRan?.my_cp?.receiver?.image}`
            }
            onError={() => handleError(CpTopRan?.my_cp?.receiver?.image)} // Handle error for individual image
            className="absolute right-[3.5rem] rounded-full w-16 top-[0.8rem] h-16"
          />
        ) : (
          <img
            src={fallbackImage}
            className="absolute right-[3.5rem] rounded-full w-16 top-[0.8rem] h-16"
          />
        )}
      </div> */
}
